import {useFetch, useStore} from "@vigo/hooks";
import {Select, Spin} from "antd";
import React, {useMemo} from "react";

export const IntegratorList = ({onSelect, value, ...props}) => {
    const stores = useStore();
    const [integrationsLoading, integrations] = useFetch({
        defaultDataValue: [],
        fetchFn: stores.integratorStore.integratorList.bind(null, {
            isActive: true
        }),
        initialCall: true,
        showLoading: true,
        dependencies: [],
    });
    const data = useMemo(() => {
        return (integrations?.data ?? []).map(integration => (
            <Select.Option key={integration._id} title={integration.name} value={integration._id}>
                {integration.name}
            </Select.Option>
        ));
    }, [integrations]);

    return (
        <Spin spinning={integrationsLoading}>
            <Select
                allowClear
                showSearch
                onChange={onSelect}
                value={value}
                filterOption={(input, option) => option.title.toLocaleUpperCase("tr-TR").includes(input.toUpperCase())}
                {...props}
            >
                {
                    data
                }
            </Select>
        </Spin>
    );
};
